import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Phone, Facebook, Menu, X } from "lucide-react";
import logo from "@/assets/schober/logo.webp";

const nav = [
  { to: "/", label: "HOME" },
  { to: "/aktuelles", label: "AKTUELLES" },
  { to: "/leistungen", label: "LEISTUNGEN" },
  { to: "/ueber-uns", label: "ÜBER UNS" },
  { to: "/faq", label: "FAQ" },
] as const;

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* Top orange bar */}
      <div className="bg-brand-orange text-brand-orange-foreground text-sm">
        <div className="container mx-auto max-w-7xl flex items-center justify-between px-4 py-3">
          <a
            href="tel:00436802308700"
            className="flex items-center gap-2 font-normal hover:opacity-90"
          >
            <Phone className="h-4 w-4" />
            <span>Rufen Sie uns an: +43 680 230 87 00</span>
          </a>
          <a
            href="https://www.facebook.com/schoberentruempelungen"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            className="hover:opacity-80"
          >
            <Facebook className="h-4 w-4" />
          </a>
        </div>
      </div>

      {/* Main nav */}
      <div className="bg-background border-b border-border">
        <div className="container mx-auto max-w-7xl flex items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-center" aria-label="Schober Transportservice – Startseite">
            <img
              src={logo}
              alt="Schober Transportservice"
              className="h-14 w-auto md:h-16"
              width={300}
              height={80}
            />
          </Link>

          <nav className="hidden items-center gap-10 lg:flex">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className="text-md font-normal text-brand-navy transition-colors hover:text-brand-orange"
                activeProps={{ className: "text-brand-orange" }}
                activeOptions={{ exact: n.to === "/" }}
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/kontakt"
              className="rounded-full bg-brand-orange px-6 py-2.5 text-sm font-bold text-brand-orange-foreground shadow-sm transition-all hover:scale-105 hover:bg-brand-orange/90"
            >
              KONTAKT
            </Link>
          </nav>

          <button
            className="lg:hidden"
            aria-label="Menü"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div className="border-t border-border bg-background lg:hidden">
            <div className="container mx-auto flex flex-col gap-1 px-4 py-3">
              {nav.map((n) => (
                <Link
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2 text-sm font-semibold text-brand-navy hover:bg-muted"
                >
                  {n.label}
                </Link>
              ))}
              <Link
                to="/kontakt"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-full bg-brand-orange px-6 py-2.5 text-center text-sm font-bold text-brand-orange-foreground"
              >
                KONTAKT
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
